var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'd-flex': true, 'justify-end': !_vm.isMobile, 'text-left': _vm.isMobile }},[_c('div',{staticClass:"pa-4 grey-background"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }